module.exports = __webpack_public_path__ + "img/wsb-howtoplay-images-01.af4a6df0.jpg";